import React, { useState, useEffect } from "react";
import LineBox from "../../../../DefaultStyles/LineBox";
import Table, {
  TableBody,
  TableBodyItem,
  TableHead,
  TableHeadContainer,
  TableHeadItem,
} from "../../../../Table/Table";
import MatchMakingPartyFilter, {
  matchMakingPartyFilter,
} from "./components/N_MatchMakingPartyFilter";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../ApiTS/ServiceDatasTS";
import Flex from "../../../../DefaultStyles/Flex";
import LineBtn from "../../../../Button/LineBtn";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authType } from "../../../../../pages/Login";
import { useApi } from "../../../../../hooks/useApi";
import SpaceBetween from "../../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../../Table/Pagination";
import { TotalCount } from "../../../../../pages/Users/UserInfo";
import {
  decryptPW,
  getEllipsis,
  getThousandComma,
} from "../../../../../ApiTS/ApiCommonTS";
import Loader from "../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IMatchPartyEmail } from "../EmailInfo";
import MatchMakingEmailInfoModal from "../EmailInfo/components/N_MatchMakingEmailInfoModal";
import { chatTabState } from "../../ChatInfo/ChatTab";
import { recentChatBtnClick } from "../../ChatInfo/ChatSearch/ChatSearchResult";
import PartyMailModal from "../../PartyDetail/PartyDetailShareInfo/PartyMailModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface IMatchParty {
  id: number;
  comment?: string;
  email: string;
  startdate: string;
  enddate: string;
  servsubsid: number;
  password: string;
  party: {
    partyid: number;
    member: { uid: number }[];
  }[];
}

export default function MatchMakingParty() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const filter = useRecoilValue(matchMakingPartyFilter);
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  const [emailModal, setEmailModal] = useState<{
    modal: boolean;
    data?: IMatchPartyEmail;
  }>({
    modal: false,
    data: undefined,
  });
  const [linkidMailModal, setLinkidMailModal] = useState({
    modal: false,
    email: "",
  });

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.adminSet
      ? `matchParty/NewMatchList?page=${page}&size=10` +
        (filter?.searchValue !== "" ? `&partyid=${filter?.searchValue}` : "") +
        (filter?.subsId !== "" ? `&servsubsid=${filter?.subsId}` : "")
      : undefined,
  });

  const tableHead = [
    "Subscription",
    "계정 이름",
    "이메일",
    // "비밀번호",
    "파티 기간",
    "파티 A",
    "파티 B",
    "코멘트",
    "계정 관리",
  ];

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "뉴 매치메이킹 파티 정보를 불러오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <MatchMakingPartyFilter
        refetch={() =>
          fetchData({
            method: "get",
            url: auth?.adminSet
              ? `matchParty/NewMatchList?page=${page}&size=10` +
                (filter?.subsId !== "" ? `&servsubsid=${filter?.subsId}` : "")
              : undefined,
          })
        }
      />

      <LineBox>
        <Table
          customTableHeader={
            <TableHead>
              <TableHeadContainer>
                {tableHead?.map((t, index) => {
                  return (
                    <>
                      {t && (
                        <TableHeadItem
                          key={index}
                          colSpan={
                            t === "파티 A" || t === "파티 B" ? 3 : undefined
                          }
                        >
                          {t}
                        </TableHeadItem>
                      )}
                    </>
                  );
                })}
              </TableHeadContainer>
            </TableHead>
          }
        >
          <>
            {response?.data?.map((d: IMatchParty) => {
              const subsData = GetSubscriptionSetData(d?.servsubsid);
              const svcData = GetServiceSetData(subsData?.SVC_ID ?? 0);

              return (
                <TableBody key={d?.id}>
                  <TableBodyItem isKeepAll={true}>
                    {getSubsNameBySubsId3(d?.servsubsid)}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {`${svcData?.SVC_NMKR_TEMP ?? ""}_${d?.id ?? 0}` ?? "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() =>
                      setLinkidMailModal({
                        modal: true,
                        email: d?.email,
                      })
                    }
                  >
                    {d?.email}
                  </TableBodyItem>
                  {/* <TableBodyItem>
                    {d?.password ? decryptPW(d?.password, 1)?.pw : "-"}
                  </TableBodyItem> */}
                  <TableBodyItem isKeepAll={true}>
                    {d?.startdate}~{d?.enddate}
                  </TableBodyItem>

                  {Array(2)
                    .fill(1)
                    .map((_, i) => (
                      <React.Fragment key={i}>
                        <TableBodyItem
                          clickable={d?.party?.[i]?.partyid ? true : false}
                          onClick={() => {
                            if (d?.party?.[i]?.partyid) {
                              navigate(`/party/info/${d?.party?.[i]?.partyid}`);
                            }
                          }}
                        >
                          {d?.party?.[i]?.partyid ?? "-"}
                        </TableBodyItem>

                        {Array(2)
                          .fill(1)
                          .map((_, j) => (
                            <TableBodyItem key={j}>
                              {d?.party?.[i]?.member?.[j]?.uid ? (
                                <Flex gapSize={8}>
                                  <LineBtn
                                    icon="chat"
                                    sPadding="0 7px"
                                    btnClickEvent={() => {
                                      setTab(1);
                                      setRecentBtnClick(true);

                                      navigate({
                                        pathname: `/party/chat`,
                                        search: `${
                                          d?.party?.[i]?.partyid
                                        }@${1}@${
                                          d?.party?.[i]?.member?.[j]?.uid
                                        }`,
                                      });
                                    }}
                                  />
                                  <span
                                    onClick={() =>
                                      navigate(
                                        `/users/info/${d?.party?.[i]?.member?.[j]?.uid}`
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {d?.party?.[i]?.member?.[j]?.uid}
                                  </span>
                                </Flex>
                              ) : (
                                "-"
                              )}
                            </TableBodyItem>
                          ))}
                      </React.Fragment>
                    ))}

                  <TableBodyItem>
                    {d?.comment ? getEllipsis(d?.comment, 15) : null}
                  </TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="수정하기"
                      btnClickEvent={() =>
                        setEmailModal({
                          modal: true,
                          data: {
                            id: d?.id,
                            email: d?.email,
                            servsubsid: d?.servsubsid,
                            comment: d?.comment,
                            password: d?.password,
                            partyid: [
                              d?.party[0]?.partyid,
                              d?.party[1]?.partyid,
                            ],
                          },
                        })
                      }
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}

      {linkidMailModal.modal && (
        <PartyMailModal
          closeEvent={() =>
            setLinkidMailModal({
              modal: false,
              email: "",
            })
          }
          mailId={linkidMailModal.email}
          type={
            linkidMailModal.email?.includes("testgrove.pw") ||
            linkidMailModal.email?.includes("linkidmail.com")
              ? "db"
              : "mailgun"
          }
        />
      )}

      {emailModal.modal && (
        <MatchMakingEmailInfoModal
          closeEvent={() =>
            setEmailModal({
              modal: false,
              data: undefined,
            })
          }
          refetch={() =>
            fetchData({
              method: "get",
              url: auth?.adminSet
                ? `matchParty/NewMatchList?page=${page}&size=10` +
                  (filter?.subsId !== "" ? `&servsubsid=${filter?.subsId}` : "")
                : undefined,
            })
          }
          data={emailModal.data}
        />
      )}
    </>
  );
}
